/**
 * Created by Carsten Bühler
 * User: CBuehler on 16.12.2015
 * Copyright: xdot GmbH 2015
 */
'use strict';


import { DataUtil } from 'plugin/liferay-widgets-react-web';
import L from 'external/leaflet';

export default class MapConfigPlugin {

    constructor(props) {
        this.boundRequestHandled = false;
        this.boundRequestCb = this.boundRequestCb.bind(this);
    }

    init(map) {
        console.log('MapConfigPlugin init()', map);
        this.map = map;
    }

    initOptions(o) {
        console.log('MapConfigPlugin initOptions()');
        let mapConfig = DataUtil.asItem(o.mapConfig);
        if (mapConfig) {
            let bb = mapConfig.boundingBox;
            if (bb && bb.latitudeMax && bb.longitudeMax) {
                const southWest = L.latLng(bb.latitudeMin, bb.longitudeMin),
                    northEast = L.latLng(bb.latitudeMax, bb.longitudeMax);

                o.boundRequest = {
                    bounds: L.latLngBounds(southWest, northEast),
                    options: { animate: false },
                    cb: this.boundRequestCb
                };
            }
        }
        return this.options(o);
    }

    options(o) {
        let mapConfig = DataUtil.asItem(o.mapConfig);

        if (mapConfig) {
            o = {
                ...o,
                layerDescriptions: (o.layerDescriptions || []).concat(mapConfig.children || []),
                baseLayerDescriptions: (o.baseLayerDescriptions || []).concat(mapConfig.baseLayer || []),
                defaultBaseLayerId: mapConfig.defaultBaseLayerId
            }
        }

        return o;
    }

    boundRequestCb() {
        this.boundRequestHandled = true;
    }
}

MapConfigPlugin.staticPlugin = true;




// WEBPACK FOOTER //
// ./js/plugins/MapConfigPlugin.js